import httpClient from 'shared/utils/http-client'
import { AffiliateSettingsApiInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface'

export const AFFILIATE_SETTINGS_API = '/api/dashboard/settings/affiliate-withdrawal'

export const updateUserAffiliateSettings = (data: AffiliateSettingsApiInterface) =>
  httpClient.put(AFFILIATE_SETTINGS_API, data)
